import type { SpellTargetingDispatcher } from "./SpellTargetingDispatcher.js";

/**
 * Engine-wide singleton reference to the active `SpellTargetingDispatcher`.
 *
 * `main.tsx` constructs the dispatcher once at boot; UI surfaces that drive
 * targeting (battle board, PartyBar armed mode) read it via
 * `getSpellTargeting()` to call `commitOnEntity` / `commitOnCell` /
 * `finalize` / `cancel` directly. Mirrors the `combatManagerRef` pattern.
 */

let _dispatcher: SpellTargetingDispatcher | null = null;

export function setSpellTargeting(d: SpellTargetingDispatcher | null): void {
  _dispatcher = d;
}

export function getSpellTargeting(): SpellTargetingDispatcher | null {
  return _dispatcher;
}
